// extracted by mini-css-extract-plugin
export var contentContainer = "resource-module--content-container--d5930";
export var contentType = "resource-module--content-type--d2e3a";
export var description = "resource-module--description--76cba";
export var hero = "resource-module--hero--4b3fa";
export var pullUp = "resource-module--pull-up--9ddc6";